// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import AppShotsController from "./app_shots_controller"
application.register("app-shots", AppShotsController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import ChipFilterController from "./chip_filter_controller"
application.register("chip-filter", ChipFilterController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FilterChipController from "./filter_chip_controller"
application.register("filter-chip", FilterChipController)

import FitHeightController from "./fit_height_controller"
application.register("fit-height", FitHeightController)

import HistoryBackController from "./history_back_controller"
application.register("history-back", HistoryBackController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import PlanPeriodController from "./plan_period_controller"
application.register("plan-period", PlanPeriodController)

import RevealController from "./reveal_controller"
application.register("reveal", RevealController)

import RollCallController from "./roll_call_controller"
application.register("roll-call", RollCallController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import TimeZoneController from "./time_zone_controller"
application.register("time-zone", TimeZoneController)
